import { useEffect } from 'react';
import { useFormState } from 'shared';

export function useTobaccoProductForm(product, onChangeInput) {
  const [productInputs, setProductInputs] = useFormState(product, onChangeInput);

  useEffect(() => {
    setProductInputs({ ...product }, false);
  }, [product]);

  const handleChange =
    fieldName =>
    ({ target }) => {
      setProductInputs(inputs => ({ ...inputs, [fieldName]: target.value }));
    };

  return {
    productInputs,
    handleChange
  };
}
